import { BaseService } from './base.service'
import { ErrorWrapper, ResponseWrapper } from './util'
import axios from 'axios'
import { API_REPORT_URL, API_VERSION, API_VERSION_1 } from '@/.env'
import localStorageKey from '@/constants/localStorageKey'
import { getItemByLocalStorage } from '@/utils/localStorage'
import reportType from '@/config/reportType'
var qs = require('qs')

export default class ReportService extends BaseService {
  static get entity () {
    return 'orders'
  }

  static async getReportByStore (type, query, store, storeId = null, isExportExcel = false, isGetChart = false) {
    const isGlobalStores = window.location.pathname === '/global-stores'
    const isGlobal = window.location.pathname === '/global'
    let fields = ''
    let typeSummary = ''
    let source = ''
    try {
      if (!isGetChart) {
        store.commit('common/SET_LOADING', true)
      }
      if (window.location.pathname === '/order-status') {
        switch (type) {
          case reportType.orders:
            fields = reportType.orderStatusFields
            break
          case reportType.saleSummary:
            fields = reportType.saleSummaryOrderFields
            break
        }
      } else {
        fields = ''
      }
      if (type === reportType.saleSummary) {
        if (reportType.revenuaTab.includes(window.location.pathname.slice(1, window.location.pathname.length))) {
          typeSummary = 'revenue'
        } else if (reportType.ordersTab.includes(window.location.pathname.slice(1, window.location.pathname.length))) {
          typeSummary = 'all'
        }
        query.states = window.location.pathname === '/payment-status' ? [] : query.states
      } else {
        typeSummary = ''
      }
      if (type === reportType.orders) {
        source = 'in_store'
        query.states = window.location.pathname === '/payment-status' ? [] : query.states
      } else {
        source = ''
      }
      const response = await axios.get(`${API_REPORT_URL}/${type === 'orders' ? API_VERSION_1 : API_VERSION}/stores/${storeId || getItemByLocalStorage(localStorageKey.STORE_ID)}/${type}`, {
        params: {
          ...query,
          statuses: query.statuses ? (query.statuses || []).join(',') : query.statuses,
          states: query.states ? (query.states || []).join(',') : query.states,
          outletIds: query.outletIds ? (query.outletIds || []).join(',') : query.outletIds,
          productTypes: query.productTypes ? (query.productTypes || []).join(',') : query.productTypes,
          registerIds: query.registerIds ? (query.registerIds || []).join(',') : query.registerIds,
          fields: fields,
          type: typeSummary,
          source: source,
          isExport: isExportExcel,
          revenueType: query.revenueType ? 'revenue' : ''
        },
        paramsSerializer: params => {
          return qs.stringify(params, { encode: false, skipNulls: true })
        }
      })
      if (response.data.items) {
        const data = response.data
        if (!isGlobal && !isGlobalStores) {
          if (!isExportExcel) {
            store.commit('common/SET_LOADING', false)
          }
        }
        return new ResponseWrapper(response, data)
      } else {
        if (!isGlobal && !isGlobalStores) {
          store.commit('common/SET_LOADING', false)
        }
      }
    } catch (error) {
      store.commit('common/SET_LOADING', false)
      throw new ErrorWrapper(error, error?.message)
    }
  }
}
